import {useToast} from "vue-toastification";

const fire = (message, config) => {
    const toast = useToast();
    toast(message, config);
};

export const showInfoMessage = (message, config = {}) => {
    fire(message, {...config, type: "info"});
};

export const showSuccessMessage = (message, config = {}) => {
    fire(message, {...config, type: "success"});
};

export const showDangerMessage = (message, config = {}) => {
    fire(message, {...config, type: "error"});
};

export const showExceptionMessage = (e, prefixMessage = '') => {
    console.error(e);

    const message = prefixMessage + e?.response?.data?.message ?? e.message;
    showDangerMessage(message, {timeout: 10000});
};
